import React from 'react';

export default function IconCheck(props) {
    return (
        <svg
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}>
            <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
                <polyline
                    id="Path-2-Copy-23"
                    stroke={props.stroke || '#008FFF'}
                    strokeWidth="1.4"
                    points="11 14.1193979 13.980007 17 19 12"
                />
            </g>
        </svg>
    );
}
